import { action, observable } from "mobx";
import ProviderCreditBalanceRepository from "~/repository/Provider/ProviderCreditBalanceRepository";
import NestStore from "~/stores/NestStore";

class ProviderCreditBalanceStore extends NestStore {
  /**
   * @property {number}
   */
  @observable amount = 0;

  /**
   * Immersive 3D Tours whose processing failed for lack of credits and is waiting on this balance.
   * @property {Array<{tourId: number, title: string, stage: string, requiredCredits: number|null}>}
   */
  @observable pendingImmersive3dTours = [];

  /**
   * Credits still missing for every pending tour to go through (0 when none is pending).
   * @property {number}
   */
  @observable missingCredits = 0;

  /**
   * @property {ProviderCreditBalanceRepository|null}
   */
  providerCreditBalanceRepository = null;

  constructor() {
    super();

    this.providerCreditBalanceRepository = new ProviderCreditBalanceRepository();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).then(() => {
      this.isLoading = false;
    });
  }

  @action
  getOne() {
    return this.providerCreditBalanceRepository.fetchOne().then(response => {
      this.amount = response.data.providerCreditBalance;
      this.pendingImmersive3dTours = response.data.pendingImmersive3dTours || [];
      this.missingCredits = response.data.missingCredits || 0;
    });
  }
}

export default ProviderCreditBalanceStore;
